import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const DataPage_AppSettings_QueryDocument = graphql(`
  query DataPage_AppSettings_Query {
    appSettings {
      enableFixtures
    }
  }
`);

export const useAppSettingsQuery = () =>
  useGraphQLQuery(DataPage_AppSettings_QueryDocument);
